import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { RoleGroupService } from 'src/app/_services/role-group.service';
import { RoleGroup } from '../../../_models/roleGroup';
import { AdminService } from '../../../_services/admin.service';

declare var $ : any;
@Component({
  selector: 'app-new-permission',
  templateUrl: './new-permission.component.html',
  styleUrls: ['./new-permission.component.css']
})
export class NewPermissionComponent implements OnInit {
  permissionList=[]

  roleGroup = new RoleGroup()
  searchRoleForm:FormGroup
  constructor(
    private adminService:AdminService,
    private activatedRoute:ActivatedRoute,
    private roleGroupService:RoleGroupService,
    private router:Router
  ) {

  }

  ngOnInit(): void {
    this.initForm()
    this.onChanges()
    this.activatedRoute.params.subscribe(
      params=>{
        this.roleGroup.server_role_group_id = +params['id']
        this.roleGroupService.getRoleGroupById(this.roleGroup.server_role_group_id).subscribe(
          {
            next: (x:ResultData)=>{
            this.roleGroup = x.rs.data
          }
          }
        )
      }
    )
  }

  initForm(){
   this.searchRoleForm= new FormGroup(
      {'searchInput': new FormControl('')}
      )
  }


  onChanges(): void {
    this.searchRoleForm.get('searchInput').valueChanges.subscribe(val => {
      if(val.length>2){

        this.adminService.searchRoles(val,this.roleGroup.server_role_group_id).subscribe(
          x=>{
            this.permissionList=x
          }
        )
    }else{
      this.permissionList=[]
    }
  })
}

addPermission(server_role_id:number){
  this.adminService.addPermissionToGroup(server_role_id,this.roleGroup.server_role_group_id).subscribe(
    x=>{
      this.roleGroup=x
    }
  )
}
}


